import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import DetailService from '../../../../service/detail';
import { CaseInfo } from '../../data';
import { userGradeType } from '../../../../utils/auth';
import ExpectedDividendLimitTable from './ExpectedDividendLimitTable';
import ExpectedModal from './ExpectedModal';
import { useReportContext } from '../../../../context/DetailContext';
import LimitTable from '../../../components/limit/DetailLimitTable';

export interface IExpectedDividendProps {
  info: {
    creation_dt: string | number;
    minprice: string | number;
    pre_auct_depo: string | number;
    auct_cost: string | number;
    act_dist_amt: string | number;
  };
  list: Array<{
    rank: string | number;
    creditor: string | number;
    max_bond_amt: string;
    div_amt: string;
    div_rate: string;
    un_div_amt: string;
    acqu_amt: string;
    remain_amt: string;
    is_extinc: string;
    idx: string;
  }>;
}

//html태그 제거
const cleanText = (input: any) => {
  // 입력값에 HTML 태그가 포함되어 있는지 확인
  if (!/<[^>]+>/g.test(input)) {
    return input; // 태그가 없으면 그대로 반환
  }

  // HTML 태그를 제거하고 <br> 태그를 공백으로 변경
  return input
    .replace(/<br\s*\/?>/g, ' ') // <br> 태그를 공백으로 변경
    .replace(/<[^>]+>/g, ''); // 모든 HTML 태그 제거
};

const ExpectedDividendTable = ({
  expectedDividend,
  iidx,
  caseInfo,
}: {
  expectedDividend: IExpectedDividendProps;
  iidx: number;
  caseInfo: CaseInfo;
}) => {
  const { regionAccess, quotaAccess } = useReportContext();
  const [expectData, setExpectData] = useState(expectedDividend || {});
  const [m_price, setM_price] = useState(0);
  const [m_price2, setM_price2] = useState('');
  const [showExpectedModal, setShowExpectedModal] = useState(false);

  const info = expectData.info ? expectData.info : '';

  const list = expectData.list ? expectData.list : [];

  const getExpectData = async () => {
    try {
      const res = await DetailService.dividend(iidx, m_price);
      setExpectData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (m_price) {
      getExpectData();
    }
  }, [m_price]);
  const saleDate = new Date(caseInfo.saleDate);
  const today = new Date();

  // 한국 시간 변환 (UTC +9)
  const koreanToday = new Date(today.getTime() + 9 * 60 * 60 * 1000);
  const displayDate =
    saleDate < today
      ? new Date(caseInfo.saleDate).toLocaleString('ko-KR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      : koreanToday.toISOString().replace('T', ' ').substring(0, 19);

  return (
    <Container id="예상배당표">
      {!quotaAccess || !regionAccess ? (
        <Content>
          <Title>예상 배당표 </Title>
          <LimitTable title="예상 배당표는" />
        </Content>
      ) : (
        <>
          <Content>
            <Title>예상 배당표 </Title>
            <ContentItem>
              <ContentItemTitle>
                <img src="/assets/images/icon/money-graph.svg" alt="" />
                입찰예상가 설정하기
              </ContentItemTitle>
              <InputContainer>
                <InputBox>
                  <ExpetedAmountInput
                    type="text"
                    placeholder="금액입력"
                    value={m_price2}
                    onChange={(e) =>
                      setM_price2(
                        Number(
                          e.target.value.replace(/[^0-9]/g, ''),
                        ).toLocaleString(),
                      )
                    }
                  />
                  <ApplyButton
                    onClick={() => {
                      setM_price(Number(m_price2.replace(/[^0-9]/g, '')));
                    }}
                  >
                    적용
                  </ApplyButton>
                </InputBox>
                <Desription>
                  *예상 배당표는 등기부를 기준으로 작성되었으며, 채권 금액과
                  내용에 따라 사실과 다를 수 있으므로 참고용으로 사용
                  (면책조건으로 제공됨)
                </Desription>
              </InputContainer>
            </ContentItem>
            <ListItemColorBox>
              <ListItem>
                <span>배당표 작성일</span>
                {displayDate}
              </ListItem>
              <ListItem>
                <span>입찰예상가</span>
                {info && ReportFormatNumber(info.minprice)}
              </ListItem>
            </ListItemColorBox>
          </Content>

          <Content>
            <ContentItemTitle>
              <img src="/assets/images/icon/icon_research.svg"></img>
              예상 배당표 작성을 위한 기본 전제
            </ContentItemTitle>
            <ContentItem>
              <DataListItem>
                <span>배당표 작성일</span>
                {displayDate}
              </DataListItem>
              <Divider />
              <DataListItem>
                <span>전경매보증금</span>
                {info &&
                  (info?.pre_auct_depo &&
                  !String(info?.pre_auct_depo).includes('금')
                    ? info.pre_auct_depo
                    : '-')}
              </DataListItem>
              <Divider />
              <DataListItem>
                <span>경매집행비용</span>
                {info && ReportFormatNumber(info.auct_cost)}
              </DataListItem>
              <Divider />
              <DataListItem>
                <span>본건(예상)배당액</span>
                {info && ReportFormatNumber(info.act_dist_amt)}
              </DataListItem>
              <Divider />
            </ContentItem>
          </Content>

          <ContentItem>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <TableHeadTh width={'22%'}>순위/ 권리</TableHeadTh>
                  <TableHeadTh width={'26%'}>채권자/ 채권액</TableHeadTh>
                  <TableHeadTh width={'26%'}>
                    배당액/{<br />}배당비율
                  </TableHeadTh>
                  <TableHeadTh width={'26%'}>
                    매수인 인수금액/ 소멸 여부
                  </TableHeadTh>
                </tr>
              </thead>
              <tbody>
                {list.length > 1 &&
                  list.slice(0, 3).map((item, index) => (
                    <tr key={index}>
                      <TablebodyTd width={'22%'}>
                        {item.idx}/{item.rank}
                      </TablebodyTd>
                      <TablebodyTd width={'26%'}>
                        {item.creditor}/<br></br>
                        {ReportFormatNumber(
                          item.max_bond_amt.replaceAll(',', ''),
                        )}
                      </TablebodyTd>
                      <TablebodyTd
                        width={'26%'}
                        // style={{ backgroundColor: '#E6F3FF' }}
                      >
                        {!item.div_amt && !item.div_rate
                          ? '-'
                          : `${ReportFormatNumber(item.div_amt)}
                    ${item.div_rate ? `/ ${item.div_rate}%` : '-'}`}
                      </TablebodyTd>
                      <TablebodyTd
                        width={'26%'}
                        style={{
                          backgroundColor: '#FBEBEC',
                          color:
                            item.is_extinc === '소멸' ? '#F34545' : '#171e26',
                        }}
                      >
                        {ReportFormatNumber(item.acqu_amt)}/
                        {cleanText(item.is_extinc)}
                      </TablebodyTd>
                    </tr>
                  ))}
              </tbody>
            </table>
            <MoreButtonContainer>
              <ButtonDivider />
              <MoreButton onClick={() => setShowExpectedModal(true)}>
                예상 배당표 더보기 {'>'}
              </MoreButton>
              <ButtonDivider />
            </MoreButtonContainer>
          </ContentItem>
        </>
      )}
      {showExpectedModal && (
        <ExpectedModal
          list={list}
          onClose={() => setShowExpectedModal(false)}
        />
      )}
    </Container>
  );
};

export default ExpectedDividendTable;

interface WidthProps {
  width: string;
}

interface DateProps {
  isFirst: boolean;
}

const DateContent = styled.div<DateProps>`
  padding: 10px 12px;
  width: 100%;
  color: #616161;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  display: flex;
  justify-content: center;
  background-color: ${({ isFirst }) => (isFirst ? '#f7f8fc' : 'white')};
  font-size: ${({ isFirst }) => (isFirst ? '13px' : '14px')};
`;

const DateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e9ea;
  border-bottom: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #222;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  background-color: #fff;
`;

const Title = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ContentItemTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`;
const ContentItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 10px 4px;
  background: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
  word-wrap: break-word;
`;
const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e8e9ea;
  &:first-child {
    border-top: 1px solid #222;
  }
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #171e26;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const InputBox = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
`;
const ExpetedAmountInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 12px 16px;
  border-radius: 8px;
  border: none;
  outline: none;
  background-color: #f5f7fa;
  font-size: 16px;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;

  color: #222;
  &::placeholder {
    color: #9ea5b599;
  }
`;
const ApplyButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  background-color: #008aff;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: white;
  cursor: pointer;
`;
const Desription = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #37383c9c;
`;

const ListItemColorBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 10px 16px;
  gap: 8px;
  background: #f7f8fc;
`;

const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  font-size: 14px;

  span {
    font-size: 12px;
    color: #616161;
  }
`;

const DataListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  text-align: end;
  gap: 8px;

  span {
    white-space: nowrap;
    text-align: start;
    font-size: 13px;
    color: #616161;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f3f5f7;
`;

const MoreButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f7f7f9;
`;

const MoreButton = styled.button`
  width: fit-content;
  padding: 8px 20px;
  background-color: #f7f7f9;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  color: #616161;
  white-space: nowrap;

  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: center;
  align-items: center;
`;
